<template>
    <div class="banner">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>内容管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>Banner管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <!--搜索区-->
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="平台">
                        <el-input v-model="searchForm.platform" placeholder="平台" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="名称">
                        <el-input v-model="searchForm.name" placeholder="名称" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.status" placeholder="品牌状态" size="mini">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="无效" value="0"></el-option>
                            <el-option label="有效" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <!--数据展示区-->
                <el-table stripe :data="tableData" v-loading="loading" style="width: 100%" size="mini" :height="tableConfig.height">
                    <el-table-column label="Banner" width="130">
                        <template scope="scope">
                            <img width="100%"  :src="'/api'+scope.row.pictureUrl">
                        </template>
                    </el-table-column>
                    <el-table-column prop="platform" label="所属平台"/>
                    <el-table-column prop="name" label="名称"/>
                    <el-table-column prop="redirectUrl" label="跳转地址"/>
                    <el-table-column prop="startTime" label="生效时间"/>
                    <el-table-column prop="endTime" label="失效时间"/>
                    <el-table-column prop="sort" label="排序"/>
                    <el-table-column prop="status" label="状态">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.status ===  1 ? 'primary' : 'info'" disable-transitions>
                                {{scope.row.status === 1 ? "有效" : "无效" }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="right" width="120">
                        <template slot="header">
                            <el-button type="primary" @click="handleCreate" size="mini">添加</el-button>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text"  size="mini" @click="handleEdit(scope.$index, scope.row)">编辑信息</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button type="text"  size="mini" @click="handleDelete(scope.$index, scope.row)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                            background
                            layout="sizes,prev, pager, next"
                            :total="total"
                            :page-sizes="[10, 20, 50, 100]"
                            v-if="total>0"
                            :page-size="pageSize"
                            @size-change="handleSizeChange"
                            @current-change="onPageChange"
                            :current-page="currentPage"
                            @prev-click="onPageChange"
                            @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>

        <el-dialog title="轮播图" :visible.sync="editDialogVisible" :before-close="handleClose"  width="500px">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="80px" size="mini">
                <el-form-item label="图片" prop="pictureUrl">
                    <el-upload
                            class="avatar-uploader"
                            ref="upload"
                            action="/api/admin/upload"
                            name="file"
                            list-type="picture-card"
                            :show-file-list="false"
                            :file-list="fileList"
                            :on-exceed="onExceed"
                            :before-upload="beforeUpload"
                            :on-preview="handlePreview"
                            :on-success="handleSuccess"
                            :on-remove="handleRemove">
                        <img v-if="editForm.pictureUrl" width="100%" :src="'/api'+editForm.pictureUrl"  class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="视频" prop="video" size="mini">
                    <el-upload
                        class="upload-demo"
                        action="/api/admin/upload"
                        name="file"
                        :limit="1"
                        :on-success="handleVideoSuccess"
                        :on-remove="handleVideoRemove"
                        :file-list="videoList">
                        <el-button size="mini" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传视频文件，且不超过1G</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="所属平台" prop="platform" size="mini">
                    <el-input v-model="editForm.platform" placeholder="请输入所属平台" clearable></el-input>
                </el-form-item>
                <el-form-item label="名称" prop="name" size="mini">
                    <el-input v-model="editForm.name" placeholder="请输入名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="链接地址" size="mini">
                    <el-input v-model="editForm.redirectUrl" placeholder="请输入链接地址" clearable></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort" size="mini">
                    <el-input v-model="editForm.sort" placeholder="请输入排序" clearable></el-input>
                </el-form-item>
                <el-form-item label="生效时间" prop="startTime" size="mini">
                    <el-date-picker
                            v-model="editForm.startTime"
                            type="date"
                            placeholder="生效时间" value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions0" clearable>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="失效时间" prop="endTime" size="mini">
                    <el-date-picker
                            v-model="editForm.endTime"
                            type="date"
                            placeholder="失效时间" value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions1" clearable>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="状态" size="mini">
                    <el-select v-model="editForm.status" placeholder="请选择品牌状态">
                        <el-option label="无效" value="0"></el-option>
                        <el-option label="有效" value="1"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="onSubmit" size="mini">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    const HEIGHT_OFFSET = 118;
    export default {
        data() {
            return {
                pageLoading: undefined,
                tableConfig: {
                    height: 0,
                },
                searchForm: {
                    name: "",
                    status: "",
                },
                loading: false,
                total: 0,
                pageSize: 10,
                currentPage: 1,
                tableData: [],
                editDialogVisible: false,
                editForm: {
                    id: "",
                    name: "",
                    pictureUrl: "",
                    videoName: "",
                    videoUrl: "",
                    redirectUrl: "",
                    platform: "",
                    startTime: "",
                    endTime: "",
                    sort: "",
                    status: "1",
                },
                //文件上传的参数
                dialogVisible: false,
                //图片列表（用于在上传组件中回显图片）
                fileList: [{name: '', url: ''}],
                videoList: [],
                rules: {
                    pictureUrl: [
                        { required: true, message: '请选择Banner图片', trigger: 'blur' }
                    ],
                    name: [
                        { required: true, message: '请输入名称', trigger: 'blur' }
                    ],
                    redirectUrl: [
                        { required: true, message: '请输入链接地址', trigger: 'blur' }
                    ],
                    platform: [
                        { required: true, message: '请输入所属平台', trigger: 'blur' }
                    ],
                    sort: [
                        { required: true, message: '请输入排序', trigger: 'blur' }
                    ],
                    startTime: [
                        { required: true, message: '请选择生效时间', trigger: 'blur' }
                    ],
                    endTime: [
                        { required: true, message: '请选择失效时间', trigger: 'blur' }
                    ]
                },
            }
        },
        methods: {
            onSearch() {
                let banner = {};
                if (this.searchForm.platform != "") {
                    banner["platform"] = this.searchForm.platform;
                }
                if (this.searchForm.name != "") {
                    banner["name"] = this.searchForm.name;
                }
                if (this.searchForm.status != "") {
                    banner["status"] = this.searchForm.status;
                }

                this.loading = true;

                let _this = this
                this.$axios.post("/admin/banner/search", {
                    cond: banner,
                    page: this.currentPage - 1,size:this.pageSize
                }).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        _this.loading = false;
                        _this.tableData = resp.data.content;
                        _this.total = resp.data.totalElements;
                    }
                }).catch(function (error) {
                });
            },
            handleCreate() {
                this.editForm.id = "";
                this.editForm.name = "";
                this.editForm.pictureUrl = "";
                this.editForm.redirectUrl = "";
                this.editForm.platform = "";
                this.editForm.startTime = "";
                this.editForm.endTime = "";
                this.editForm.sort = "";
                this.editForm.status = "1";
                this.videoList = [];
                this.editDialogVisible = true;
            },
            onSubmit() {
                let that = this;
                this.$refs.editForm.validate(valid => {
                    if (valid) {
                        this.$axios.post("/admin/banner/save", this.editForm)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                that.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                that.editDialogVisible = false;
                                that.onSearch();
                            } else {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                    }
                });
            },
            handleSizeChange(pageSize){
                this.pageSize = pageSize;
                this.onSearch();
            },
            onPageChange(currentPage) {
                this.currentPage = currentPage;
                this.onSearch();
            },
            handleEdit(index, row) {
                this.editForm.id = row.id;
                this.editForm.name = row.name;
                this.editForm.pictureUrl = row.pictureUrl;
                this.editForm.redirectUrl = row.redirectUrl;
                this.editForm.platform = row.platform;
                this.editForm.startTime = row.startTime;
                this.editForm.endTime = row.endTime;
                this.editForm.sort = row.sort;
                this.editForm.status = row.status + "";
                this.videoList = [{name: row.videoName, url: row.videoUrl}];
                this.editDialogVisible = true;
            },
            handleDelete(index, row) {
                let _this = this;
                this.$confirm('是否删除该Banner信息【' + row.name + '】？', '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '删除',
                    cancelButtonText: '取消'
                }).then(() => {
                    _this.$axios.get("/admin/banner/delete/" + row.id)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status === 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据删除成功',
                                    type: 'success'
                                });
                                _this.onSearch();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                })
            },
            //文件上传成功的钩子函数
            handleSuccess(res, file) {
                this.$message({
                    type: 'info',
                    message: '图片上传成功',
                    duration: 6000
                });
                if (file.response.data.success) {
                    this.editForm.pictureUrl = file.response.data.message; //将返回的文件储存路径赋值picture字段
                }
            },
            //删除文件之前的钩子函数
            handleRemove(file, fileList) {
                this.$message({
                    type: 'info',
                    message: '已删除原有图片',
                    duration: 6000
                });
            },
            //点击列表中已上传的文件事的钩子函数
            handlePreview(file) {
            },
            //上传的文件个数超出设定时触发的函数
            onExceed(files, fileList) {
                this.$message({
                    type: 'info',
                    message: '最多只能上传一个图片',
                    duration: 6000
                });
            },
            //文件上传前的前的钩子函数
            //参数是上传的文件，若返回false，或返回Primary且被reject，则停止上传
            beforeUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isGIF = file.type === 'image/gif';
                const isPNG = file.type === 'image/png';
                const isBMP = file.type === 'image/bmp';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG && !isGIF && !isPNG && !isBMP) {
                    this.$message.error('上传图片必须是JPG/GIF/PNG/BMP 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
            },
            //文件上传成功的钩子函数
            handleVideoSuccess(res, file) {
                if (file.response.data.success) {
                    this.editForm.videoName = file['name'];
                    this.editForm.videoUrl = file.response.data.message;
                }
            },
            //删除文件之前的钩子函数
            handleVideoRemove() {
                this.editForm.videoName = "";
                this.editForm.videoUrl = "";
            },
            handleClose() {},

            setTableHeight() {
                const tablePosition = this.$refs['tablePosition'];
                const {top} = tablePosition.getBoundingClientRect();
                this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
            }
        },
        mounted() {
            this.pageLoading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(() => {
                this.setTableHeight();
                this.pageLoading.close();
                this.pageLoading = undefined;
            }, 500);
        },
        beforeDestroy() {
            if(this.pageLoading){
                this.pageLoading.close();
                this.pageLoading = undefined;
            }
        },
        created() {
            window.addEventListener("resize", this.setTableHeight);
            this.onSearch();
        },
        destroyed () {
            window.removeEventListener("resize", this.setTableHeight);
        }
    }
</script>
<style>
</style>
